<template>
  <div>
    <!-- 选择置顶时间的对话框 -->
    <el-dialog
      title="选择置顶时间"
      :visible.sync="dialogVisible"
      width="40%"
      :modal-append-to-body="true"
      append-to-body
      close-on-click-modal
      @closed="handleClose"
    >
      <el-form ref="form" :rules="rules" :model="form">
        <el-form-item label="置顶时间" prop="topTime" label-width="100px">
          <el-date-picker
            :picker-options="{
              disabledDate(time) {
                return time.getTime() < Date.now() - 8.64e7;
              },
            }"
            size="small"
            v-model="form.topTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="置顶开始时间"
            end-placeholder="置顶结束日期"
            clearable
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <!-- 保存和取消 -->
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="hide">取 消</el-button>
        <el-button size="small" type="primary" @click="save">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "WebSaaSTimeSelect",

  data() {
    return {
      /** 需要绑定的卡片id */
      cardId: "",
      dialogVisible: false,
      rules: {
        topTime: [
          {
            required: true,
            validator: (rule, value, callback) => {
              console.log("置顶时间", value);
              if (value === undefined || value.length === 0) {
                callback(new Error("请选择置顶时间"));
              } else {
                // 校验开始时间，大于当前时间
                if (value[0]) {
                  // 将字符串格式的开始时间转换为Date对象
                  const startTime = new Date(value[0]);

                  // 检查转换是否成功，且开始时间是否大于当前时间
                  if (
                    isNaN(startTime.getTime()) ||
                    startTime.getTime() < Date.now()
                  ) {
                    callback(new Error("置顶开始时间不能小于当前时间"));
                  }
                }
                if (value[1]) {
                  // 将字符串格式的结束时间转换为Date对象
                  const endTime = new Date(value[1]);

                  // 检查转换是否成功，且结束时间是否大于开始时间
                  if (
                    isNaN(endTime.getTime()) ||
                    endTime.getTime() < new Date(value[0]).getTime()
                  ) {
                    callback(new Error("置顶结束时间不能小于开始时间"));
                  }
                }
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      form: {
        topTime: [],
      },
    };
  },

  methods: {
    /** 确认的事件 */
    save() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$emit("save", {
            cardId: this.cardId,
            topTime: this.form.topTime,
          });
          this.hide();
        }
      });
    },
    //^ ^--------------对话框自身相关-------------^ ^
    show(id) {
      this.cardId = id || "";
      this.dialogVisible = true;
    },
    hide() {
      this.dialogVisible = false;
    },
    handleClose() {
      this.cardId = "";
      this.form.topTime = [];
      /** 清除表单验证规则 */
      this.$refs["form"].clearValidate();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>